import moment from "moment";

export const GARMENTS_TRACKING_FILTER_KEY =
  "digitalization-garments-tracking_filter_value";

export const getStoredGarmentsTrackingFilters = () => {
  try {
    const stored = localStorage.getItem(GARMENTS_TRACKING_FILTER_KEY);
    if (!stored) {
      return {};
    }
    return JSON.parse(stored);
  } catch {
    return {};
  }
};

export const formatGarmentsTrackingFiltersForApi = (stored) => {
  if (!stored || typeof stored !== "object") {
    return {};
  }

  return Object.fromEntries(
    Object.entries({
      per_page: stored.per_page || 10,
      date: stored.date ? moment(stored.date).format("YYYY-MM-DD") : undefined,
      line_id: stored.line_id || undefined,
      buyer_id: stored.buyer_id || undefined,
      style_id: stored.style_id || undefined,
      sub_style_id: stored.sub_style_id || undefined,
    }).filter(
      ([_, value]) => value !== undefined && value !== null && value !== "",
    ),
  );
};

export const formatGarmentsTrackingFiltersForForm = (stored) => {
  if (!stored || typeof stored !== "object") {
    return {};
  }

  return {
    ...stored,
    date: stored.date ? moment(stored.date) : undefined,
  };
};
